import React from "react";
import logo from "../assets/SEPM_Logo.svg";

export default function SepmLogo({ className = "h-10 w-10", alt = "SEPM" }) {
  return <img src={logo} alt={alt} className={className} />;
}
